import { render, staticRenderFns } from "./TemplateTreeList.vue?vue&type=template&id=52b21358&scoped=true"
import script from "./TemplateTreeList.vue?vue&type=script&lang=js"
export * from "./TemplateTreeList.vue?vue&type=script&lang=js"
import style0 from "./TemplateTreeList.vue?vue&type=style&index=0&id=52b21358&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52b21358",
  null
  
)

export default component.exports